
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.01468 2.06527C5.79646 2.13382 5.59802 2.25406 5.43626 2.41576L2.41577 5.43614C2.25407 5.5979 2.13382 5.79633 2.06527 6.01454C1.99673 6.23275 1.9819 6.46429 2.02206 6.68946C2.06222 6.91463 2.15618 7.12677 2.29593 7.30784C2.43569 7.4889 2.61712 7.63353 2.82478 7.72942L3.90167 8.22686C4.24557 8.38544 4.54896 8.62006 4.78893 8.91302C5.0289 9.20598 5.19919 9.54963 5.28694 9.91801L5.76086 11.9094C6.01812 12.9903 7.36118 13.3701 8.14674 12.5846L9.93533 10.7952L12.9534 13.814C13.0095 13.8721 13.0766 13.9185 13.1509 13.9505C13.2251 13.9824 13.305 13.9992 13.3858 14C13.4666 14.0007 13.5468 13.9854 13.6216 13.9548C13.6964 13.9242 13.7644 13.8791 13.8215 13.8219C13.8787 13.7648 13.9239 13.6969 13.9546 13.6221C13.9852 13.5473 14.0006 13.4672 14 13.3864C13.9993 13.3056 13.9826 13.2257 13.9507 13.1514C13.9188 13.0772 13.8725 13.01 13.8144 12.9538L10.7955 9.93506L12.5849 8.14652C13.3705 7.361 12.9907 6.01798 11.9098 5.76073L9.91829 5.28682C9.54989 5.19908 9.20623 5.0288 8.91326 4.78884C8.62029 4.54887 8.38566 4.2455 8.22708 3.9016L7.72961 2.82475C7.63372 2.6171 7.48909 2.43568 7.30802 2.29592C7.12695 2.15617 6.9148 2.06222 6.68962 2.02206C6.46444 1.9819 6.2329 1.99673 6.01468 2.06527Z","fill":"#10001F"}})])
          )
        }
      }
    